export const SITE_ORIGIN = "https://dadbanan.com";
export const SITE_NAME = "مؤسسه دادبانان";
export const DEFAULT_OG_IMAGE = `${SITE_ORIGIN}/images/logo.png`;

export function toAbsoluteUrl(canonical?: string | null) {
  if (!canonical || !String(canonical).trim()) {
    return SITE_ORIGIN;
  }

  let value = String(canonical).trim();

  if (/^https?:\/\/(www\.)?dadbanan\.com\/https?:\/\//i.test(value)) {
    value = value.replace(/^https?:\/\/(www\.)?dadbanan\.com\//i, "");
  }

  if (/^https?:\/\//i.test(value)) {
    return value.replace(
      /^https?:\/\/(www\.)?dadbanan\.com(?=\/|$)/i,
      SITE_ORIGIN
    );
  }

  return `${SITE_ORIGIN}/${value.replace(/^\//, "")}`;
}

export function isNoIndexPath(path: string) {
  const clean = path.split("?")[0].split("#")[0];
  return /^(?:\/auth|\/basket|\/payment-status|\/student|\/search|\/show-headlines)(?:\/|$)/.test(
    clean
  );
}
